<template>
  <div>
    <DonateWithFormParams />
  </div>
</template>

<script>
import DonateView from "@/components/DonateView"
import withFormParams from "@/components/withFormParams"

const DonateWithFormParams = withFormParams(DonateView)
export default {
  name: "DonateRoute",
  components: {
    DonateWithFormParams
  }
}
</script>